export const pythonInteractiveCards = [
  {
    title: "Variables",
    to: "/11th/computer/python/variables/",
    description: "Variable naming, assignment aur basic examples yahan se prepare karo.",
  },
  {
    title: "Data Types",
    to: "/11th/computer/python/data-types/",
    description: "int, float, string aur boolean ko examples ke sath yahan se samjho.",
  },
  {
    title: "Operators",
    to: "/11th/computer/python/operators/",
    description: "Arithmetic aur comparison operators ko exam style me yahan se cover karo.",
  },
  {
    title: "Input / Output",
    to: "/11th/computer/python/programs/#input-output-playground",
    description: "Input aur print output ko visual practice ke sath yahan se samjho.",
  },
  {
    title: "Loops",
    to: "/11th/computer/python/loops/",
    description: "For loop, while loop aur board-style loop questions yahan se cover karo.",
  },
  {
    title: "Comments",
    to: "/11th/computer/python/comments/",
    description: "Code aur comment ka farq examples ke sath samjho.",
  },
  {
    title: "Functions",
    to: "/11th/computer/python/functions/",
    description: "Functions, parameters aur return concept ko examples ke sath samjho.",
  },
  {
    title: "Programs",
    to: "/11th/computer/python/programs/",
    description: "Output, coding aur board-style practical questions yahan se practice karo.",
  },
] as const;

export const pythonInteractiveRouteByConcept = {
  variables: "/11th/computer/python/variables/",
  "data-types": "/11th/computer/python/data-types/",
  comments: "/11th/computer/python/comments/",
  "input-output": "/11th/computer/python/programs/",
  operators: "/11th/computer/python/operators/",
  expressions: "/11th/computer/python/operators/",
  "if-else": "/11th/computer/python/programs/",
  loops: "/11th/computer/python/loops/",
  functions: "/11th/computer/python/functions/",
  modules: "/11th/computer/python/functions/",
} as const;
